import React, { useEffect, useState, useRef } from "react";
import { Alert } from "reactstrap";
import ApplicationsTable from "../../components/applicationsTable";
import Pagination from '../../components/pagination/pagination';
import TableModal from "../../components/tableModal";
import ViewLayout from "../../components/viewLayout";
import { useFetch } from "../../utils/fetchHook";

import { getCookie } from "../../jwt/_helpers/cookie";
import TableHelper from "../../components/tableHelper";

const Applications = props => {
  const token = getCookie("token");
  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [deleteBody, setDeleteBody] = useState(false);
  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);

  const [forceUpdate, setForce] = useState(1);

  const handlerValues = { setSuccess, setError, forceUpdate, setForce };
  const [tableData, setTableData] = useState([]);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '', name: 'name', sort: 'name'});
  const [apiData, error, loading] = useFetch("GET", "applications/applications/?page_size=9999", token);

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const tableProps = {
    tableData,
    defaultSorted
  };

  let applicationsEnabled = true;
  
  useEffect(() => {
    if (apiData?.count != null) {
      setDataCount(apiData.count);
    }
    if (Array.isArray(apiData?.results)) {
      setTableData(apiData.results);
    } else if (Array.isArray(apiData)) {
      setTableData(apiData);
    }
  }, [currrentPage, pageSize, apiData]);

  
  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name]);


  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          { 
            (!applicationsEnabled) &&
            <Alert color="danger">
              You don't have access to this module, please contact the support team for further information.
            </Alert>
          }
          {
            (applicationsEnabled) &&
            <>
              <ViewLayout title={"Your applications list"} hideSampleDataNotice>
                <ApplicationsTable
                  {...tableProps}
                  setToggleModal={setToggleModal}
                  setDataModal={setDataModal}
                  setDeleteBody={setDeleteBody}
                  forceUpdate={forceUpdate}
                  searchQuery={{setQuery, query, ordering, setOrdering}}
                  />
              </ViewLayout>
              <Pagination pagination={paginationProps}/>
            </>
          }
        </div>
      )}

      {dataModal && (
        <TableModal
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          values={handlerValues}
          title={
            deleteBody ? (!dataModal.can_be_deleted? `Application ${dataModal.name} can't be deleted`: `Delete ${dataModal.name}?`) : `Edit ${dataModal.name}?`
          }
          body={
            deleteBody? (
              !dataModal.can_be_deleted?
                `Application ${dataModal.name} can't be deleted!.`:
                "Are you sure you really want to delete this application?."
            ): "Are you sure you want to edit your application."
          }
          apiURL={`applications/${dataModal.id}/`}
          bodyID={dataModal.id}
          deleteBody={deleteBody}
          can_be_deleted={dataModal.can_be_deleted}
        />
      )}
      {success && <Alert color="success">Artist has been removed!</Alert>}
      {errorPut && (
        <Alert color="danger">
          Something went wrong! Please refresh page and try again!
        </Alert>
      )}
    </>
  );
};

export default Applications;